import {Component, ElementRef, ViewChild} from '@angular/core';
import {NavController,ToastController,AlertController} from 'ionic-angular';
import { Headers , RequestOptions } from '@angular/http';

import {SearchCustomersPage} from "../search-customers/search-customers";

import {CartPage} from '../cart/cart';
import {CartManager} from "../../providers/cart-manager";

import {ItemsPage} from '../items/items';


import {Api} from '../../providers/api';

import {IMAGES_BASE_URL,Constants,ApplicationVariables } from '../../providers/config';

import 'rxjs/add/operator/map';
import { Storage } from '@ionic/storage';
import {NavParams } from 'ionic-angular';
import {Printer, PrintOptions} from 'ionic-native';
import { MsgManager } from '../../providers/msg-manager';
import {CART, loginUserInfo, RoutingInfo} from '../../providers/data';
import {GVLogger} from "../../services/gv-logger";
import {ItemPage} from "../item-details/item-details";
import {LoginPage} from "../login/login";
import {FileUploader} from "ng2-file-upload";
import {MyOrderPage} from "../my-order/my-order";
import {Base64} from "js-base64";


@Component({
  selector: 'page-order-view',
  templateUrl: 'order-view.html'
})
export class OrderViewPage {

  baseImageUrl = IMAGES_BASE_URL.imageBaseUrl;

  @ViewChild('divID') divID: ElementRef;

  isOfflineMode:any;

  salesPerson;

  currentDate;
  placeOrderButton = true;
  customerType = ""

  attributesPropertiesMap:any = new Map();
  shipto = '';
  constants = Constants;

  space: string = ", ";
  spaceAddress1 : string;
  spaceAddress2 : string;

  adpCustomerInfo :any ={};
  TAX = 0;

  public cart: any;
  public TotalPrice: number =0;
  public TotalPriceBeforeTax: number = 0;
  public taxPercent = 0; // Changed from 0.13
  public taxAmount = 0;
  public locationSelected: any;
  public locationSelectedObject: any;
  public expectedShipmentDate: any = "";
  public orderMessage = "";
  spaceCity: string;
  spaceState: string;
  order: any;
  selectFirstBillTo: any;
  spaceZipCode: any;
  priceBeforeShippingCost;
  shippingCost;
  totalTax = 0.0;
  totalConsumerTax = 0.0;
  totalConsumerShippingCost = 0.0;
  isB2CSaleChannel = true;
  isB2BDropshipper = true;

  public uploader: FileUploader = new FileUploader({});
  public hasBaseDropZoneOver: boolean = false;
  fileIsOver:boolean;
  documents = [];

  restrictedToViewOrder = loginUserInfo.restrictedToViewOrder;
  newOrderMessage = ""
  public TotalPriceBeforeTaxAmount: number = 0;
  selectedCurrency = ""

  constructor(public nav: NavController,
              private cartManager:CartManager,
              private api:Api,public storage: Storage,
              public toastCtrl: ToastController,
              public params:NavParams,
              public alertCtrl: AlertController,
              private msgManager:MsgManager, private gVLogger: GVLogger) {

    this.customerType = loginUserInfo.customerType;
    this.attributesPropertiesMap = this.cartManager.getAllAttributesPropertiesMap();
    this.adpCustomerInfo = this.cartManager.getAdpCustomerInfo();

    this.salesPerson = this.cartManager.getSalesPerson();
    this.isOfflineMode  = ApplicationVariables.isOffline;

    this.cart = this.params.get("cart");
    this.order = this.params.get("orderView");
    if (this.order.totalTexAmount != null && this.order.totalTexAmount != undefined && this.order.totalTexAmount != "")
      this.totalTax = this.order.totalTexAmount
    this.gVLogger.log("order" + JSON.stringify(this.order) );

    if(this.order.salesChannel === "B2B Store" || this.order.salesChannel === "B2B Sales Rep" || this.order.salesChannel === "B2B Warehouse" || this.order.salesChannel === "B2B Dropshipper" || this.order.salesChannel === "B2B Non-Dropshipper" || this.order.salesChannel === "None"){
      this.isB2CSaleChannel = false;
    }


    if(this.order.salesChannel === "B2B Store" || this.order.salesChannel === "B2B Sales Rep" || this.order.salesChannel === "B2B Warehouse" || this.order.salesChannel === "None"){
      this.isB2BDropshipper = false;
    }

    for ( let item of this.cart.items){

      item.price = this.decimalLengthFixed(item.price,2)
      if(this.discountCheck(item.discountPrice)){
        item.discountPrice = this.decimalLengthFixed(item.discountPrice,2)
      }


      this.totalConsumerTax += item.consumerSaleTax;
      this.totalConsumerShippingCost += item.consumerShippingCost;

      item.attributesList = [];

      if(!item.attributeSearch){
        // item.attributeSearch = "5:2027>6:2764>7:2852>8:2875>9:2879";
        item.attributeSearch = "";
      }

      if(item.attributeSearch.indexOf('>') !== -1){
        let tempAttributesList = item.attributeSearch.split('>');
        for(let attribute of tempAttributesList){
          if(attribute!== "")
            item.attributesList.push({attributeId:attribute.split(':')[0],activeStatus: this.attributesPropertiesMap.get(attribute.split(':')[0]).attActiveStatus ,orderId:this.attributesPropertiesMap.get(attribute.split(':')[0]).attSequence||0,attribute:this.cartManager.getAttributeValue(attribute.split(':')[0]),attributeValue:this.cartManager.getAttributeValue(attribute)});
        }
      }
      item.attributesList.sort(function(a,b){return a.orderId-b.orderId})
    }


    this.gVLogger.log(this.cart);
    // this.orderMessage = this.cart.orderMessage.split("<br/>");
    this.orderMessage = this.cart.orderMessage;
    this.currentDate = new Date();
    this.expectedShipmentDate = this.cart.expectedShipmentDate;
    this.gVLogger.log(this.expectedShipmentDate);
    this.TotalPriceBeforeTax = params.get("TotalPrice");
    this.shippingCost = params.get("shippingCost");
    this.TotalPriceBeforeTaxAmount = params.get("subTotalAmount");
    if (this.shippingCost === null || this.shippingCost === undefined || this.shippingCost === ""){
      this.shippingCost = "0"
    }
    this.priceBeforeShippingCost = params.get("priceBeforeShippingCost");
    this.TotalPrice = this.TotalPriceBeforeTax + this.taxAmount;
    this.getLocationById();
    this.updateOrderMessageInCART();
    this.getDocuments();

    console.log("sssssssssssssssssssssssssssssssshhiiippppppppppppp" + this.TotalPriceBeforeTaxAmount);
    if(this.TotalPriceBeforeTaxAmount === null || this.TotalPriceBeforeTaxAmount === undefined) {
      this.TotalPriceBeforeTaxAmount = (this.TotalPriceBeforeTax - parseFloat(this.order.totalTexAmount) - parseFloat(this.order.shippingCost))
    }

    // if(loginUserInfo.multiCurrencyFlag === 1 && this.order.customerDTO.paymentCurrency !== undefined && this.order.customerDTO.paymentCurrency !== "")
    //   this.selectedCurrency = this.order.customerDTO.paymentCurrency;
    // else
    //   this.selectedCurrency = this.adpCustomerInfo.selectedCurrencySymbol

    if(this.order.currencyCode !== null && this.order.currencyCode !== undefined && this.order.currencyCode !== "")
      this.selectedCurrency =  this.order.currencyCode;
    else
      this.selectedCurrency = this.adpCustomerInfo.selectedCurrencySymbol

  }


  getLocationById(){
    if(this.cart.customer.locationsDTOs[0].dropshipLocation === undefined || this.cart.customer.locationsDTOs[0].dropshipLocation === null)
      this.locationSelectedObject = this.cart.customer.locationsDTOs[0];
    else
      this.locationSelectedObject = JSON.parse(this.cart.customer.locationsDTOs[0].dropshipLocation);

    this.setCommaAddress1();
    this.setCommaAddress2();
    this.setCommaCity();
    this.setCommaState();
    this.setCommaZipCode();
    // this.shipto = [this.locationSelectedObject.addressLine1, this.spaceAddress1, this.locationSelectedObject.addressLine2, this.spaceAddress2,  this.locationSelectedObject.city, this.spaceCity, this.locationSelectedObject.state, this.spaceState, this.locationSelectedObject.country].join("");

    this.shipto = [this.locationSelectedObject.addressLine1, this.spaceAddress1, this.locationSelectedObject.addressLine2, this.spaceAddress2, this.locationSelectedObject.city, this.spaceCity, this.locationSelectedObject.state, this.spaceState, this.locationSelectedObject.zipCode, this.spaceZipCode, this.locationSelectedObject.country].join("");


  }

  setCommaZipCode(){
    if(this.locationSelectedObject.zipCode === "" || this.locationSelectedObject.zipCode === undefined || this.locationSelectedObject.zipCode === null)
    {
      this.spaceZipCode = "";
    }
    else
    {
      this.spaceZipCode = ", ";
    }
  }

  setCommaCity(){
    if(this.locationSelectedObject.city === "" || this.locationSelectedObject.city === undefined || this.locationSelectedObject.city === null)
    {
      this.spaceCity = "";
    }
    else
    {
      this.spaceCity = ", ";
    }
  }

  setCommaState(){
    if(this.locationSelectedObject.state === "" || this.locationSelectedObject.state === undefined || this.locationSelectedObject.state === null)
    {
      this.spaceState = "";
    }
    else
    {
      this.spaceState = ", ";
    }
  }

  setCommaAddress1(){
    if(this.locationSelectedObject.addressLine1 === "" || this.locationSelectedObject.addressLine1 === undefined || this.locationSelectedObject.addressLine1 === null)
    {
      this.spaceAddress1 = "";
    }
    else
    {
      this.spaceAddress1 = " ";
    }
  }

  setCommaAddress2(){
    if(this.locationSelectedObject.addressLine2 === "" || this.locationSelectedObject.addressLine2 === undefined || this.locationSelectedObject.addressLine2 === null)
    {
      this.spaceAddress2 = "";
    }
    else
    {
      this.spaceAddress2 = ", ";
    }
  }

  // place order
  buy() {

    if(this.expectedShipmentDate == ""){
      this.msgManager.toastMsg("Please select a Shipment Date");
      // let toast = this.toastCtrl.create({
      //         message: "Please select a Shipment Date",
      //         duration: 3000
      //       });
      //       toast.present();
    }else{

      this.placeOrderButton = false;



      var body:any = this.cartManager.genrateOrder(1, loginUserInfo.customerShippingCost); // placeorder status 1


      this.gVLogger.log(JSON.stringify(body));
      let headers = new Headers({
        'Content-Type': 'application/json'
      });
      let options = new RequestOptions({
        headers: headers
      });
      //this.saveOrderOnDisk();
      this.api.post("order/place",JSON.stringify(body), options)
        .map(res => res.json())
        .subscribe(resp => {
            if(resp.status == "401"){ // check for session out
              this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());
              this.nav.setRoot(LoginPage);
            }
            if(resp.status="200"){


              this.cartManager.clearCart();
              this.cartManager.setOrderId(0); // orderid after submission
              this.cartManager.setOrderMessage("");

              this.nav.setRoot(SearchCustomersPage);
            }

          }
          , error =>{
            //alert(JSON.stringify(error));
          });

      // back to home page
      // this.nav.setRoot(HomePage);
    }

  }

  clearCart(){
    let confirm = this.alertCtrl.create({
      title: 'Are you sure?',
      message: 'Do you agree to Clear all the Products from cart',
      buttons: [
        {
          text: 'Cancel',
          handler: () => {
            this.gVLogger.log('Disagree clicked');
          }
        },
        {
          text: 'Agree',
          handler: () => {
            this.gVLogger.log('Agree clicked');
            this.cartManager.clearCartProducts();
            this.nav.pop().then(()=>{this.nav.pop()});
          }
        }
      ]
    });
    confirm.present();

  }

  saveOrderOnDisk(){

    // let keys: any = [];

    // let arrKeys = JSON.parse( localStorage.getItem("keys"));
    // let key = this.cart.customer.id + "-" + new Date();
    // alert(arrKeys);
    // if(arrKeys == null){
    //   keys.push(key);
    //   localStorage.setItem("keys",keys);
    //   localStorage.setItem(key,JSON.stringify(this.cart));
    // }else{
    //     arrKeys.push(key);
    //     localStorage.setItem("keys",arrKeys);
    //     localStorage.setItem(key,JSON.stringify(this.cart));
    // }
  }

  shipDateChanged(event){
    this.gVLogger.log(this.expectedShipmentDate);
    this.cartManager.setShipDate(this.expectedShipmentDate);
  }

  updateOrderMessageInCART(){
    this.cartManager.setOrderMessage(this.orderMessage);
  }

  updateOrderMessage($event){
    this.gVLogger.log("Blured called");
    this.updateOrderMessageInCART();
  }

  doPrint(){
    let options: PrintOptions = {
      name: 'Purchase Order'
    };

    Printer.isAvailable().then(
      function(){
        //alert("Printer is availabel");
        Printer.print(document.getElementById("print-from"), options).then(function(){},function(){});
      }
      ,
      function(){
        alert("Printer is not available");
      }
    );
  }

  imageNotFound(e,item){
    item.productImagesDTO[0].extension = "png";
    item.productImagesDTO[0].name = "dummy";
  }


  reOrder(){

    this.gVLogger.log(this.cart.customerDTO);

    if(this.cartManager.getProductsCount()){

      let confirm = this.alertCtrl.create({
        title: 'Are you sure?',
        message: "Do you agree to delete all the Products for '"+ this.cartManager.getCustomerName() +"' from cart",
        buttons: [
          {
            text: 'Goto Cart', // cancel
            handler: () => {
              this.nav.setRoot(ItemsPage).then(()=>{this.nav.push(CartPage)});
            }
          },
          {
            text: 'Discard Cart', // agree
            handler: () => {

              this.addtoCart();
            }
          }
        ]
      });
      confirm.present();

    }else{
      this.addtoCart()
    }


  }

  // addtoCart(){
  //   let customerId = this.cart.customer.id
  //
  //   this.cart.items[0].customerId = customerId
  //
  //   this.api.post("products/getUpdatedPrice",this.cart.items).map(res => res.json()).subscribe(data => {
  //     if(data.status === "200"){
  //       this.cartManager.setItems(data.data);
  //     }else {
  //       this.cartManager.setItems(this.cart.items);
  //     }
  //
  //     this.cartManager.setCustomer(this.cart.customer);
  //     this.cartManager.setOrderMessage(this.cart.orderMessage);
  //     this.cartManager.setOrderId(0);
  //     this.nav.setRoot(ItemsPage).then(()=>{this.nav.push(CartPage)});
  //   })
  //
  //
  //   // this.cartManager.setItems(this.cart.items);
  //   //this.nav.push(CartPage);
  //
  //
  //
  //
  // }

  addtoCart(){
    this.cartManager.setCustomer(this.cart.customer);
    this.cartManager.setOrderMessage(this.cart.orderMessage);
    this.cartManager.setOrderId(0);
    // this.cartManager.setItems(this.cart.items);

    for(let item of this.cart.items){
      item.customPricing = false
    }

    let customerId = this.cart.customer.id

    this.cart.items[0].customerId = customerId
    this.api.post("products/getUpdatedPrice",this.cart.items).map(res => res.json()).subscribe(data => {
      if(data.status == "401"){ // check for session out
        this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());
        this.nav.setRoot(LoginPage);
      }
      if(data.status === "200"){
        this.cartManager.setItems(data.data);
        this.nav.setRoot(ItemsPage).then(()=>{this.nav.push(CartPage)});
      }else {
        this.cartManager.setItems(this.cart.items);
        this.nav.setRoot(ItemsPage).then(()=>{this.nav.push(CartPage)});
      }
    })


  }

  discountCheck(discountPrice){ // if discount price is > 0, return true
    if(Number(discountPrice) > 0){
      return true;
    }else{
      return false;
    }
  }




  decimalLengthFixed(num,max){
    return Number(num).toFixed(Math.max(2, (num.toString().split('.')[1] || []).length))
  }



  doPrintWeb(){

    this.printToCart("print-from");

  }


  printToCart(printSectionId: string){
    let popupWinindow;
    let innerContents = document.getElementById(printSectionId).innerHTML;
    popupWinindow = window.open('', '_blank', 'width=600,height=700,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no');
    popupWinindow.document.open();
    popupWinindow.document.write('<html><head><link rel="stylesheet" type="text/css" href="style.css" /></head><body onload="window.print()">' + innerContents + '</html>');
    popupWinindow.document.close();
  }

  makeImageURL(dimensions,item){
    return this.cartManager.makeImageURL(dimensions,item);
  }


  getSquareLogo(){
    return IMAGES_BASE_URL.imageBaseUrl + "/" + this.cartManager.getADPCustomerUUID() + "/branding/logoSquare.png?v="+Math.round((new Date()).getTime() / 1000);
  }

  locationAddress1(addressLine1){
    // this.gVLogger.log("locationAddress1 called" + addressLine1);
    if(addressLine1 === "" || addressLine1 === null || addressLine1 === undefined){
      return false;
    }
    else
    {
      return true;
    }
  }

  resetOrder(){
    let confirm = this.alertCtrl.create({
      title: 'Reset Shipment & Order',
      message: 'Are you sure? You want to reset the shipment and the order',
      buttons: [
        {
          text: 'Cancel',
          handler: () => {
            //  this.gVLogger.log('Disagree clicked');
          }
        },
        {
          text: 'Agree',
          handler: () => {


            let productsList: any = [];
            for(let orderDetail of this.order.orderDetailDTOs){
              let product: any = orderDetail.productsDTO;
              productsList.push(product);
            }

            this.order.salesManId = this.cartManager.getSalesManId();
            if(productsList.length >= 0)
            {
              this.gVLogger.log("else called");
              this.api.post("order/resetOrder",this.order)
                .map(res=> res.json())
                .subscribe(data=>{
                  if(data.status == "401"){ // check for session out
                    this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());
                    this.nav.setRoot(LoginPage);
                  }
                  if(data.status == 200){
                    this.cartManager.setCustomer(this.order.customerDTO);
                    this.cartManager.setOrderMessage(this.order.orderMessage);
                    this.cartManager.setOrderId(this.order.id);
                    this.cartManager.setOrderTitle(this.cart.orderTitle);
                    this.cartManager.setOrderStatus(2);
                    this.cartManager.setShipDate(this.order.expectedShipmentDate);
                    this.cartManager.setItems(productsList);
                    this.nav.setRoot(ItemsPage).then(()=>{this.nav.push(CartPage)});


                  }
                },err=>{
                  // this.presentToast("some thing going wrong with background process");
                });

            }

          }
        },
      ]
      // }


    });
    confirm.present();
  }


  refreshTotalPrice(){
    this.cart = CART;
    let temp:number = 0;
    for(let item of this.cart.items){
      if(this.discountCheck(item.discountPrice)){
        temp =  temp + (Number(item.discountPrice) * Number(item.quantityOrdered));
      }else{

        temp =  temp + (Number(item.price) * Number(item.quantityOrdered));
      }
    }
    this.TotalPriceBeforeTax =  Number(temp.toFixed(2));
    this.TAX = (this.TotalPriceBeforeTax * this.taxPercent);
    this.TotalPrice = this.TotalPriceBeforeTax + this.TAX;
    //alert(JSON.stringify(this.cart));
  }

  locationTypeCheck(locationsDTOs){

    for(let loc of locationsDTOs){
      if(loc.isShipToAddress === 1 && loc.locationType === "BILLTOSHIPTO"){
        return this.selectFirstBillTo = loc;
      }
    }

    for(let loc of locationsDTOs){
      if(loc.locationType === "BILLTO"){
        return this.selectFirstBillTo = loc;
      }
    }
    for(let loc of locationsDTOs){
      if(loc.locationType === "BILLTOSHIPTO"){
        return this.selectFirstBillTo = loc;
      }
    }

    for(let loc of locationsDTOs){
      if(loc.locationType === "SHIPTO"){
        return this.selectFirstBillTo = loc;
      }
    }
  }

  imageNotFoundServer(event){
    event.target.src = "http://anydatapoint.net/f9c5c5ba-3900-4cdc-946d-93979d29f33c/branding/default-logo.png";
  }

  viewItem(item) {

    this.api.get("product/" + item.id + "/?isWebStore=" + 1).map(res => res.json()).subscribe(data => {
      if(data.status == "401"){ // check for session out
        this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());
        this.nav.setRoot(LoginPage);
      }
      if(data.status === "200"){
        item.description = data.data.description;
      }
    })
    this.nav.push(ItemPage, {item: item})
  }

  getCutomerOrderNumber(customerOrderNumber){
    if(customerOrderNumber !== undefined && customerOrderNumber !== null){
      return customerOrderNumber.trim()
    }else {
      return ""
    }
  }


  getFiles(){

    return this.uploader.queue.map((fileItem) => {
      return fileItem.file;
    });
  }

  deleteFile(selectedFileName){

    let confirm = this.alertCtrl.create({
      title: 'Are you sure!',
      message: 'You want to delete the selected document.',
      buttons: [
        {
          text: 'Cancel',
          handler: () => {

          }
        },
        {
          text: 'Agree',
          handler: () => {

            // this.shipOrderButton = false;

            // console.log("QQQQQQQQQQQQQQQQQQQQQ ", this.uploader.queue.splice(1,1))
            return this.uploader.queue.map((fileItem) => {
              if(selectedFileName === fileItem.file.name)
                fileItem.remove();

              // alert(fileItem.file.name);
            });



            // this.api.getADPPay("feature/getLicenseStatus?customerUUID="+this.cartManager.getADPCustomerUUID() + "&featureAlias="+ this.constants.Monthly_License_alias+"&consumptionCount=0").map(res => res.json())
            //   .subscribe(data => {
            //     if(data.status === 570 || data.status === 571 || data.status === 403){
            //
            //     }
            //     else if(data.status === 200 || data.status === 270) {
            //
            //
            //     }
            //
            //   });


          }
        },
      ]

    });
    confirm.present();



  }
  deleteFileFromDB(item){

    let confirm = this.alertCtrl.create({
      title: 'Are you sure!',
      message: 'You want to delete the selected document.',
      buttons: [
        {
          text: 'Cancel',
          handler: () => {

          }
        },
        {
          text: 'Agree',
          handler: () => {


            let body = {
              imageName : item.docName + item.docExtension
            }

            this.api.imageUploaderPost("/deleteDocuments", body, item.docModuleId, "orders", loginUserInfo.countryAbbrivation, item.sourceUuid)
              .map(res => res.json())
              .subscribe(resp => {
                  if(resp.status="200"){
                    for (let doc of this.documents){
                      console.log("item " +  item.docName)
                      console.log("doc " +  doc.docName)
                      if(doc.docName === item.docName && doc.docExtension === item.docExtension){
                        let index = this.documents.indexOf(doc)
                        if (index > -1) {
                          this.documents.splice(index, 1); // 2nd parameter means remove one item only
                        }
                      }
                    }

                    // this.nav.setRoot(MyOrderPage);

                    this.msgManager.toastMsg("Document Deleted Successfully!");
                    // do nothing
                    // alert("Documents uploaded")

                  }else{ // check for session out
                    this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());

                    // this.nav.setRoot(LoginPage);
                  }

                }
                , error =>{
                  this.msgManager.toastMsg(this.msgManager.getOrderPlaceFailMsg());
                  //alert(JSON.stringify(error));
                });


          }
        },
      ]

    });
    confirm.present();



  }
  fileOverBase(event): void {
    console.log("fileOverBase" + event)
    this.hasBaseDropZoneOver = event;

    // var e = window.event || event;
    // var target = e.target || e.srcElement;
    // var files = target.files;
    // var file = files[0];
    //
    // alert("file name " + file.name)
    //
    // this.checkFile(file);
  }
  reorderFiles(reorderEvent: CustomEvent): void {
    console.log("Reorder filesssss")
    let element = this.uploader.queue.splice(reorderEvent.detail.from, 1)[0];
    this.uploader.queue.splice(reorderEvent.detail.to, 0, element);
  }


  upload(orderId) {
    let files = this.getFiles();

    let formData = new FormData();
    // formData.append('uuid', localStorage.get("uuid")); // Add any other data you want to send
    // files.forEach((file) => {
    // formData.set('docs', "umar");
    for(let file of files){
      formData.append('docs', file.rawFile, file.name);
    }

    // for (var key of formData.has("docs")) {
    console.log("yyyyyyyyyyyyyyyyyyyyyy" + formData.get("docs"));



    this.api.imageUploaderPost("/uploadDocuments", formData, orderId, "orders", loginUserInfo.countryAbbrivation, this.order.sourceUuid)
      .map(res => res.json())
      .subscribe(resp => {
          if(resp.status="200"){
            // this.nav.setRoot(MyOrderPage);
            // alert("Documents uploaded")
            this.removeAllItemsAfterUpload()
            this.getDocuments();



          }else if(resp.status == "401"){ // check for session out
            this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());

            this.nav.setRoot(LoginPage);
          }

        }
        , error =>{
          this.msgManager.toastMsg(this.msgManager.getOrderPlaceFailMsg());
          //alert(JSON.stringify(error));
        });
  }

  getDocUrl(item){
    return RoutingInfo.imageBaseUrl + "/" + item.sourceUuid + "/docs/" + item.docModule + "/" + item.docName + "---" + item.docModuleId + item.docExtension;
    // return RoutingInfo.imageBaseUrl + "/" + item.sourceUuid + "/docs/" + item.docModule + "/" + item.docName + item.docExtension;
  }

  selectedCalled(event){
    var e = window.event || event;
    var target = e.target || e.srcElement;
    var files = target.files;
    var file = files[0];

    console.log("file name " + file.name)


    this.checkFile(file);
  }


  public onFileDrop(event): void {
    var e = window.event || event;
    var target = e.target || e.srcElement;
    var files = target.files;
    var file = files[0];

    console.log("file name " + file.name)

    // alert("file name " + file.name)

    // this.checkFile(file);
  }


  checkFile(file){

    let fileAlreadyExist = 0;

    this.uploader.queue.map((fileItem) => {
      if(file.name === fileItem.file.name){
        console.log("EXist file " + fileAlreadyExist)
        // fileItem.remove();

        fileAlreadyExist++;

        // alert(fileItem.file.name);
      }


    });

    this.documents.map((fileItem) => {
      if(file.name === fileItem.docName + fileItem.docExtension){
        console.log("EXist file " + fileAlreadyExist)
        // fileItem.remove();

        fileAlreadyExist++;

        // alert(fileItem.file.name);
      }


    });

    if(fileAlreadyExist === 2){
      this.uploader.queue.map((fileItem) => {
        if(file.name === fileItem.file.name && fileAlreadyExist === 2){
          fileItem.remove();
          this.msgManager.toastMsg("Document with the same name already exist!");
          fileAlreadyExist = 1;
          return;
        }
        // alert(fileItem.file.name);
      });
    }


    var lastIndex = file.name.lastIndexOf('.');

    let extension = file.name.substr(lastIndex);
    let name = file.name.substr(0, lastIndex)

    if(extension !== ".csv" &&
      extension !== ".doc" &&
      extension !== ".docx" &&
      extension !== ".xlsx" &&
      extension !== ".pdf" &&
      extension !== ".png" &&
      extension !== ".jpg" &&
      extension !== ".jpeg" &&
      extension !== ".jfif" &&
      extension !== ".txt" &&
      extension !== ".zip"
    ){
      return this.uploader.queue.map((fileItem) => {
        if(file.name === fileItem.file.name){
          fileItem.remove();

          this.msgManager.toastMsg("Document format not supported!");
        }


        // alert(fileItem.file.name);
      });
    }
  }


  getOrderById(orderId): Promise<any>{
    return new Promise((resolve,reject) => {
      this.api.post("order/loadByOrderId?orderId=" + orderId,null).map(res => res.json()).subscribe(OrderData => {
          this.gVLogger.log("data from /products/getProductsForPickShip : " + OrderData);
          if(OrderData.status === "200") {
            resolve(OrderData.data);
          }
          else {
            this.api.toastMSG("Some thing went wrong while getting orders.");

            reject( null);
          }
        },
        error => {
          this.api.toastMSG("Failed to fetch order data.");
          reject(error);  // ❌ Reject the promise on API failure
        }
      );
    })

  }


  public fileOver(fileIsOver: boolean): void {
    this.fileIsOver = fileIsOver;
  }



  removeAllItemsAfterUpload(){

    this.uploader = new FileUploader({})
    this.msgManager.toastMsg("Files uploaded successfully!");



    // this.uploader.queue.map((fileItem) => {
    //   // if(selectedFileName === fileItem.file.name)
    //     fileItem.remove();
    //
    //   // alert(fileItem.file.name);
    // });
  }


  getDocuments(){
    var body = {
      docModule : "orders",
      docModuleId  : this.order.id,
      sourceUuid : this.order.sourceUuid
    }
    let headers = new Headers({
      'Content-Type': 'application/json'
    });
    let options = new RequestOptions({
      headers: headers
    });
    this.api.post("getDoc", body, options)
      .map(res => res.json())
      .subscribe(resp => {
          if(resp.status == "401"){ // check for session out
            this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());
            this.nav.setRoot(LoginPage);
          }
          if (resp.status === "200") {
            // alert(resp.data)
            this.documents = resp.data;
          }

        }
        , error => {

        });
  }

  getDisabledStatus(item){
    if(this.cartManager.getADPCustomerUUID() === item.sourceUuid){
      return true;
    }else {
      return false;
    }
  }

  pushToLog(order){
    let body = {
      id : order.id,
      orderMessage : this.newOrderMessage
    }

    this.api.post("order/pushComment", body).map(res => res.json())
      .subscribe(resp => {
          if(resp.status == "401"){ // check for session out
            this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());
            this.nav.setRoot(LoginPage);
          }
          if (resp.status == "200") {
            // alert(resp.data)
            // this.documents = resp.data;
            this.msgManager.toastMsg("Comment logged successfully.");

            this.orderMessage = resp.data;
            this.newOrderMessage = "";
            this.nav.setRoot(MyOrderPage);
          }else {
            this.msgManager.toastMsg("Something went wrong while pushing comment.");
          }

        }
        , error => {

        });
  }


  commentHtml(description){
    // this.gVLogger.log( "decjsdkld ghjd gnkxdhn   : " + atob(description));

    try {
      // this.gVLogger.log("In try decoded description : " + Base64.decode(description));
      // this.gVLogger.log("In try encoded description : " + description);
      this.divID.nativeElement.innerHTML = description;
    }
    catch (e) {
      this.gVLogger.log("In catch decoded description : ")
      this.divID.nativeElement.innerHTML = description;
    }
  }

  CommentHtmlPrint(description){
    // this.gVLogger.log( "decjsdkld ghjd gnkxdhn   : " + atob(description));

    try {
      // this.gVLogger.log("In try decoded description : " + Base64.decode(description));
      // this.gVLogger.log("In try encoded description : " + description);
      this.divID.nativeElement.innerHTML = description;
    }
    catch (e) {
      this.gVLogger.log("In catch decoded description : ")
      this.divID.nativeElement.innerHTML = description;
    }
  }

  getTaxPercentage(percentage){
    if(percentage !== null && percentage !== undefined && percentage !== ""){
      return percentage
    }
    return 0;
  }

}



// WEBPACK FOOTER //
// ./src/pages/order-view/order-view.ts